import { Component, OnInit } from '@angular/core';
import { CaseQuickComponent } from '../case-quick/case-quick.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseService } from '@app/core/services/case.service';
import { PotentialParticipantService } from '@app/core/services/potential-participant.service';
import { ParticipantsService } from '@app/core/services/participants.service';
import { OfficeService } from '@app/core/services/office.service';
import { ClaimTypeService, ClaimTypeUriBuilderParams } from '@app/core/services/claim-type.service';
import { BaseWithIdList } from '@app/shared/models/list';
import { ClaimType } from '@app/shared/models/claim-type';
import { OP } from '@app/core/services/base/base-service-with-bundle.service';
import { DrFileMeta } from '@app/shared/models/dr-file';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { FileActions } from '@app/shared/models/file-actions';
import { CaseSettings } from '@app/shared/models/case-settings';
import { CaseNumberService, CaseNoSettingsUriBuilderParams } from '@app/core/services/case-number.service';
import { CaseNoStructure, GenerationMethod } from '@app/shared/models/case-number-settings';
import { Observable } from 'rxjs';
import { CaseNumberDialogComponent } from '@app/modules/case/components/case-number-dialog/case-number-dialog.component';
import { RequirementItem, RequirementsTypeService } from '@app/core/services/requirements.service';
import { map, tap } from 'rxjs/operators';

@Component({
  templateUrl: './case-detailed-general.component.html',
  styleUrls: ['./case-detailed-general.component.scss']
})
export class CaseDetailedGeneralComponent extends CaseQuickComponent
                                          implements OnInit {

    private requirementsList: RequirementItem[] = [];
    public claimTypesList!: BaseWithIdList<ClaimType>;
    public requirementsList$!: Observable<RequirementItem[]>;
  
    public disabledOptions = [
      FileActions.DELETE,
      FileActions.DOWNLOAD
  ];

  public caseSettingsWorkInstructions = CaseSettings.WORK_INSTRUCTIONS;
  public caseNumberLocked: boolean;

  get selectedClaimType(): ClaimType {
      return this.case && this.claimTypesList && this.claimTypesList.getItem(this.case.claim_type_id);
  }

  set selectedClaimType(type: ClaimType) {
      const patchData = [{
          op: type ? OP.replace : OP.remove,
          path: 'claim_type_id',
          value: type ? type.id : null
      }, {
          op: type ? OP.replace : OP.remove,
          path: 'claim_type',
          value: type ? type.name : null
      }];

      this.patchOpDataArray(patchData);
  }


    get selectedRequirement(): RequirementItem {
        return this.case && this.requirementsList && this.requirementsList.find(v => v.code === this.case.requirement_id);
    }

    set selectedRequirement(requirement: RequirementItem) {
        const patchData = [{
            op: requirement ? OP.replace : OP.remove,
            path: 'requirement_id',
            value: requirement ? requirement.code : null
        }, {
            op: requirement ? OP.replace : OP.remove,
            path: 'requirement',
            value: requirement ? requirement.value : null
        }];

        this.patchOpDataArray(patchData);
    }

  constructor(protected componentServiceBundle: ComponentServiceBundle,
              protected caseService: CaseService,
              protected potentialParticipantService: PotentialParticipantService,
              protected participantsService: ParticipantsService,
              protected officeService: OfficeService,
              protected claimTypeService: ClaimTypeService,
              protected fileUtilityService: FileUtilityService,
              protected requirementsTypeService: RequirementsTypeService,
              protected caseNumberService: CaseNumberService) {
      super(componentServiceBundle, caseService, potentialParticipantService, participantsService, officeService, claimTypeService);
      this._idPrefix = 'case_detailed_general.';
  }

  public ngOnInit() {
      super.ngOnInit();

      this.claimTypeService.query(new ClaimTypeUriBuilderParams())
                           .subscribe((result) => {
          this.claimTypesList = result;
      });

      this.requirementsList$ = this.requirementsTypeService.get().pipe(
          map(v => v.data),
          tap(list => this.requirementsList = list)
      );
      

      this.caseNumberLocked = true;
  }

  public viewFile(drFileMeta: DrFileMeta): void {
      this.fileUtilityService.viewFileInNewTab(drFileMeta);
  }

  public editCaseNumber(): void {
      this.caseNumberService.getById(new CaseNoSettingsUriBuilderParams())
                            .subscribe((result) => {
          const structure = result.office_structures.find((x) => x.reference_id === this.case.office_id);

          if (structure) {
              if (structure.generation_method === GenerationMethod.MANUAL) {
                  this.caseNumberLocked = false;
              } else {
                  this.openCaseNumberModal(structure, result.office_structures)
                      .subscribe(dialogResult => {
                      if (dialogResult && dialogResult.selectedOffice) {
                          this.patchParams = { queryParams: { updateCaseNo: true } };

                          this.patchOffice(dialogResult.selectedOffice, () => {
                              this.patchParams = null;
                              this._selectedOffice = dialogResult.selectedOffice;

                              // Update breadcrumbs with the new case number
                              this.breadcrumbsService.breadcrumbs.splice(0, 1, { url: '#', label: this.case.case_no, disabled: true });
                          });
                      }
                  });
              }
          }
      });
  }

  public openCaseNumberModal(structure: CaseNoStructure, officeStructures: CaseNoStructure[]): Observable<any> {
      const dialogRef = this.dialog.open(CaseNumberDialogComponent, {
        width: '400px',
        data: {
            case: this.case,
            caseNoStructure: structure,
            officeStructures: officeStructures,
            offices: this.offices,
            selectedOffice: this.selectedOffice
        }
      });

      return dialogRef.afterClosed();
  }

  public patchCaseNumber(): void {
      this.patchAndUpdate('case_no', () => {
          this.caseNumberLocked = true;
      });
  }

}
